/* eslint-disable unused-imports/no-unused-vars */
import { Component, Input, OnInit } from '@angular/core';
import {
	AbstractControl,
	ControlValueAccessor,
	FormControl,
	NG_VALIDATORS,
	NG_VALUE_ACCESSOR,
	ValidationErrors,
} from '@angular/forms';

@Component({
	selector: 'rating-component',
	templateUrl: 'rating.component.html',
	styleUrls: ['./rating.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: RatingComponent,
		},
		{
			provide: NG_VALIDATORS,
			multi: true,
			useExisting: RatingComponent,
		},
	],
})
export class RatingComponent implements ControlValueAccessor, OnInit {
	@Input() formControl: FormControl;

	public rating: number;
	public previewRating: number;
	public ratingKey: string = 'RATING_NONE';

	public onChange = (rating) => {};
	public onTouched = () => {};
	public touched = false;

	constructor() {}

	public ngOnInit(): void {
		this.rating = this.formControl.value;
	}

	public setRating(score: number) {
		this.rating = score;
		this.previewRating = null;
		this.formControl.patchValue(this.rating);
	}

	public showPreview(e: MouseEvent) {
		this.previewRating = parseInt((e.target as HTMLElement).id);
	}

	public hidePreview(e: MouseEvent) {
		this.previewRating = null;
	}

	public writeValue(rating: number) {
		this.rating = rating;
	}

	public registerOnChange(onChange: any) {
		this.onChange = onChange;
	}

	public registerOnTouched(onTouched: any) {
		this.onTouched = onTouched;
	}

	public markAsTouched() {
		if (!this.touched) {
			this.onTouched();
			this.touched = true;
		}
	}

	public validate(control: AbstractControl): ValidationErrors | null {
		return null;
	}
}
